
import {Routes,RouterModule } from '@angular/router'; 
import {InfoPredstavnik } from './infopredstavnik/infopredstavnik' ;
import {InfoPredstavnikzb } from './infopredstavnikzb/infopredstavnikzb' ;
import {InfoMajstor } from './infomajstor/infomajstor' ;
import {InfoStan } from './infostan/infostan' ;
import {HomePage } from './myhome/homepage' ;
import {LoginComponent } from './mylogin/loginpage' ;

const appRoutes :Routes = [
         { path: 'infopredstavnik',     component : InfoPredstavnik },
         { path: 'infopredstavnikzb',     component : InfoPredstavnikzb },
       { path: 'infomajstor',     component : InfoMajstor },
    { path: 'infostan',     component : InfoStan },
{ path: 'home',     component : HomePage },
{ path: 'login',     component : LoginComponent }
// , { path: '', pathMatch : 'full',redirectTo:'all' }
 , { path: '', pathMatch : 'full',redirectTo:'/login' }


];
export const routing = RouterModule.forRoot(appRoutes) ;


// WEBPACK FOOTER //
// ./src/app/app.routing.ts